import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CURRENT_APPLICATION_APPLICANTS } from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { mapGetters } from "vuex";
import Select2 from "@Shared/components/inputs/select2.vue";
import { formatApplicantsData } from "@Shared/@Utils/utils";
import { cloneDeep, isArray, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicantSelect",
  components: {
    Select2
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    id: {
      type: String,
      required: true
    },
    onlyApplicantsWithEmail: {
      type: Boolean,
      default: true
    },
    dropdownParent: {
      type: null,
      default: "body"
    },
    value: {
      type: [Array, Object],
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    applicantsToExclude: {
      type: Array,
      default: () => []
    },
    forceIncludeMainApplicant: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ""
    },
    autoSelectMainApplicant: {
      type: Boolean,
      default: false
    },
    autoSelectAllApplicants: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showForSingleApplicant: {
      type: Boolean,
      default: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION_APPLICANTS])), {}, {
    selectedApplicants: {
      get() {
        var _this$value;
        return (_this$value = this.value) != null ? _this$value : [];
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    selectedApplicantIndexes() {
      var _context;
      return this.multiple ? _mapInstanceProperty(_context = this.selectedApplicants).call(_context, ({
        applicantIndex
      }) => applicantIndex) : this.selectedApplicants.applicantIndex;
    },
    allApplicants() {
      var _context2;
      return _mapInstanceProperty(_context2 = this.CURRENT_APPLICATION_APPLICANTS).call(_context2, applicant => {
        const {
          id,
          applicantIndex,
          "personal-details": personalDetails
        } = applicant;
        return _objectSpread(_objectSpread({}, personalDetails), {}, {
          applicantIndex,
          applicantId: id
        });
      });
    },
    applicantsWithEmail() {
      var _context3;
      return _filterInstanceProperty(_context3 = this.allApplicants).call(_context3, ({
        email,
        applicantIndex
      }) => email || this.forceIncludeMainApplicant && applicantIndex === 0);
    },
    applicants() {
      if (this.onlyApplicantsWithEmail) return this.applicantsWithEmail;
      return this.allApplicants;
    },
    excludingApplicants() {
      var _context4;
      return _filterInstanceProperty(_context4 = this.applicants).call(_context4, ({
        applicantIndex
      }) => this.applicantsToExclude.every(applicant => applicant.applicantIndex !== applicantIndex));
    },
    select2Options() {
      return {
        allowClear: false,
        closeOnSelect: !this.multiple,
        dropdownCssClass: "multi-applicant-vue-select",
        dropdownParent: this.dropdownParent,
        minimumResultsForSearch: -1,
        templateSelection: this.templateSelection.bind(this),
        placeholder: this.placeholder,
        escapeMarkup(markup) {
          return markup;
        }
      };
    },
    showComponent() {
      return this.showForSingleApplicant || this.allApplicants.length > 1;
    }
  }),
  mounted() {
    this.validateProps();
    if (this.autoSelectMainApplicant) {
      var _context5;
      this.selectedApplicants = _findInstanceProperty(_context5 = this.excludingApplicants).call(_context5, applicant => "coapp" in applicant);
    } else if (this.autoSelectAllApplicants) {
      this.selectedApplicants = this.excludingApplicants;
    }
  },
  methods: {
    validateProps() {
      if (this.multiple && !isArray(this.value)) throw new Error("When the select is in the multiple mode, the value must be an array.");
    },
    formatData(data) {
      data = cloneDeep(data);
      return data && formatApplicantsData(data, applicant => applicant.applicantIndex, {
        fullName: "text"
      });
    },
    templateSelection(state) {
      return isEmpty(this.selectedApplicants) ? this.placeholder : `${this.$options.filters.getApplicantName(state.applicantIndex, state)}`;
    },
    handleChange(applicant, type) {
      var _context6;
      switch (type) {
        case "unselect":
          this.selectedApplicants = this.multiple ? _filterInstanceProperty(_context6 = this.selectedApplicants).call(_context6, a => a.applicantIndex !== applicant.applicantIndex) : null;
          break;
        case "select":
          this.selectedApplicants = this.multiple ? [...this.selectedApplicants, applicant] : applicant;
          break;
      }
      this.$emit("total", this.excludingApplicants.length);
    }
  }
});